import * as React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

export interface AppLoaderProps {
  open: boolean;
  handleClose?: () => void;
}

export function AppLoader(props: AppLoaderProps) {
  const onClose = () => {
    if (props.handleClose) {
      props.handleClose();
    }
  };

  return (
    <Backdrop
      sx={{ color: (theme) => theme.palette.grey[100], zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.open}
      onClick={onClose}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
